import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../../components/PageHero';
import { Check } from 'lucide-react';
export function CorporatePage() {
  return <div className="bg-white" data-id="element-755">
      <PageHero title="Corporate Membership" subtitle="Tailored solutions for businesses seeking premium dining and event experiences." backgroundImage="https://images.unsplash.com/photo-1556761175-5973dc0f32b7?w=1920&q=80" data-id="element-756" />

      <section className="py-24 md:py-32 relative overflow-hidden" data-id="element-757">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-758">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-759">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-760">
              <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-6" data-id="element-761">
                Enterprise Benefits
              </h2>
              <div className="w-16 h-1 bg-brand-terracotta mb-10" data-id="element-762"></div>

              <ul className="space-y-6 mb-16" data-id="element-763">
                {['Preferred rates on all private dining spaces and full restaurant buyouts.', 'Priority scheduling for corporate catering and commissary services.', 'Customized corporate gifting programs (wines, artisan goods, gift cards).', 'Flexible consolidated monthly billing and dedicated account management.', 'Transferable booking privileges for your executive team.'].map((perk, i) => <li key={i} className="flex items-start gap-4 text-brand-dark/80 text-lg font-light" data-id="element-764">
                    <div className="mt-1 bg-brand-terracotta/20 p-1 rounded-full text-brand-terracotta shrink-0" data-id="element-765">
                      <Check size={16} strokeWidth={3} data-id="element-766" />
                    </div>
                    {perk}
                  </li>)}
              </ul>
            </motion.div>

            <motion.div className="bg-brand-gray/10 p-10 md:p-14 rounded-sm relative" initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} data-id="element-767">
              <h3 className="text-3xl font-serif text-brand-dark mb-2" data-id="element-768">
                Apply for Corporate
              </h3>
              <p className="text-brand-dark/50 font-light mb-8 text-sm" data-id="element-769">
                Our corporate team will contact you to customize a package.
              </p>

              <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-770">
                <div data-id="element-771">
                  <input type="text" placeholder="Company Name" className="w-full bg-transparent border-b border-brand-dark/20 py-3 text-brand-dark focus:outline-none focus:border-brand-terracotta transition-colors" data-id="element-772" />
                </div>
                <div className="grid grid-cols-2 gap-6" data-id="element-773">
                  <input type="text" placeholder="Contact First Name" className="w-full bg-transparent border-b border-brand-dark/20 py-3 text-brand-dark focus:outline-none focus:border-brand-terracotta transition-colors" data-id="element-774" />
                  <input type="text" placeholder="Contact Last Name" className="w-full bg-transparent border-b border-brand-dark/20 py-3 text-brand-dark focus:outline-none focus:border-brand-terracotta transition-colors" data-id="element-775" />
                </div>
                <div data-id="element-776">
                  <input type="email" placeholder="Corporate Email" className="w-full bg-transparent border-b border-brand-dark/20 py-3 text-brand-dark focus:outline-none focus:border-brand-terracotta transition-colors" data-id="element-777" />
                </div>
                <div data-id="element-778">
                  <select className="w-full bg-transparent border-b border-brand-dark/20 py-3 text-brand-dark focus:outline-none focus:border-brand-terracotta transition-colors appearance-none" data-id="element-779">
                    <option value="" disabled selected data-id="element-780">
                      Primary Interest
                    </option>
                    <option data-id="element-781">Private Events / Entertaining</option>
                    <option data-id="element-782">Office Catering</option>
                    <option data-id="element-783">Corporate Gifting</option>
                    <option data-id="element-784">All of the above</option>
                  </select>
                </div>
                <button className="w-full bg-brand-dark text-white py-4 text-sm uppercase tracking-[0.2em] font-medium hover:bg-brand-terracotta transition-colors mt-4" data-id="element-785">
                  Submit Inquiry
                </button>
              </form>
            </motion.div>
          </div>
        </div>
      </section>
    </div>;
}